import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const BASE = "/api/v1/erp/stock-transfers";

export const fetchTransfers = createAsyncThunk("transfer/fetchAll", async (params?: string): Promise<any> => {
  const query = params ? `?${params}` : "";
  const response = await axios.get(`${BASE}${query}`);
  return response.data;
});

export const fetchTransferById = createAsyncThunk("transfer/fetchById", async (id: string): Promise<any> => {
  const response = await axios.get(`${BASE}/${id}`);
  return response.data;
});

export const addTransfer = createAsyncThunk("transfer/add", async (payload: any): Promise<any> => {
  const response = await axios.post(BASE, payload);
  return response.data;
});

export const transferStockCheck = createAsyncThunk(
  "transfer/stockCheck",
  async (payload: { fromLocationId: string; items: any[] }): Promise<any> => {
    const response = await axios.post(`${BASE}/stock-check`, payload);
    return response.data;
  }
);

export const updateTransfer = createAsyncThunk("transfer/update", async ({ id, payload }: any): Promise<any> => {
  const response = await axios.put(`${BASE}/${id}`, payload);
  return response.data;
});

export const dispatchTransfer = createAsyncThunk("transfer/dispatch", async (id: string): Promise<any> => {
  const response = await axios.post(`${BASE}/${id}/dispatch`);
  return response.data;
});

export const receiveTransfer = createAsyncThunk("transfer/receive", async (id: string): Promise<any> => {
  const response = await axios.post(`${BASE}/${id}/receive`);
  return response.data;
});

export const cancelTransfer = createAsyncThunk("transfer/cancel", async (id: string): Promise<any> => {
  const response = await axios.post(`${BASE}/${id}/cancel`);
  return response.data;
});

export const reverseTransfer = createAsyncThunk("transfer/reverse", async (id: string): Promise<any> => {
  const response = await axios.post(`${BASE}/${id}/reverse`);
  return response.data;
});
